import { render } from "./createArticle.vue?vue&type=template&id=119554b2"
import script from "./createArticle.vue?vue&type=script&lang=js"
export * from "./createArticle.vue?vue&type=script&lang=js"

import "./createArticle.vue?vue&type=style&index=0&id=119554b2&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__